import React from 'react'
import { Button, Container, Image, Loader, Spacer, Text } from 'roadie-ui'
import {
  Container as Framework,
  Slide,
  Video,
  Agree,
  QuizModule,
  RequiredQuiz,
} from 'components/pages/certifications/framework'
import Oops from 'components/pages/certifications/Oops'
import useDriverCert from 'components/pages/certifications/useDriverCert'
import { TRAINING_CERTS } from 'util/constants'
import slide01Intro from 'images/training/roadie-xd/01-title-slide.png'
import videoThumb1 from 'images/training/roadie-xd/02-video-thumbnail.png'
import videoThumb2 from 'images/training/roadie-xd/03-video-thumbnail.png'
import videoThumb3 from 'images/training/roadie-xd/04-video-thumbnail.png'
import videoThumb4 from 'images/training/roadie-xd/05-video-thumbnail.png'
import bannerQuizImage from 'images/training/banner-quiz.png'
import bannerPassImage from 'images/training/roadie-xd/banner-pass.png'
import bannerFailImage from 'images/training/roadie-xd/banner-fail.png'
import { LocalizedRichText, useLocalization, LocalizedText } from 'localization'

//TODO: Combine with other VimeoVideo components
const VimeoVideo: React.FC<{
  id: string
  thumbnail: string
  h?: string
}> = ({ id, h, thumbnail }) => {
  const { t } = useLocalization()
  const src = `https://player.vimeo.com/video/${id}?${h ? `h=${h}&` : ''}autoplay=0&muted=0&autopause=0&controls=1&playsinline=true&loop=0`
  return (
    <Video
      src={src}
      autoplayWhenVisible={false}
      showVideoInBackground={true}
      height="496"
      thumbnail={<img src={thumbnail} alt={t('dweb_common_video_thumbnail')} />}
    />
  )
}
const RoadieXDPage: React.FC = () => {
  const { t } = useLocalization()
  const driverCertResult = useDriverCert(TRAINING_CERTS.ROADIE_XD.CERT)

  if (driverCertResult.loading) {
    return (
      <RoadieXDModule>
        <Loader />
      </RoadieXDModule>
    )
  }

  if (driverCertResult.isDriverCertRevoked) {
    return (
      <RoadieXDModule>
        <Oops message={t('dweb_certifications_roadie_xd_revoked_ineligible_message')} />
      </RoadieXDModule>
    )
  }

  return (
    <RoadieXDModule>
      <QuizModule certification={TRAINING_CERTS.ROADIE_XD.CERT} minimumScoreToPass={3}>
        {{
          slides: (
            <>
              <Slide>
                <Image width="100%" src={slide01Intro} />
                <Spacer $height="3.2rem" />
                <Text.Overline $color="primary-base">
                  <LocalizedText translationKey="dweb_certifications_roadie_xd_deliver_big_earn_big" />
                </Text.Overline>
                <Spacer $height="0.4rem" />
                <Text.H4>
                  <LocalizedText translationKey="dweb_certifications_roadie_xd_driver_certification" />
                </Text.H4>
                <Spacer $height="0.8rem" />
                <Text.Body2>
                  <LocalizedText translationKey="dweb_certifications_roadie_xd_module_youll_learn_everything_need_know_about_roadie" />
                </Text.Body2>
              </Slide>
              <Slide>
                <Text.H5 $fontWeight="600">
                  <LocalizedText translationKey="dweb_certifications_roadie_xd_what_roadie_xd_gigs" />
                </Text.H5>
                <Spacer $height="0.8rem" />
                <Text.Body2>
                  <LocalizedText translationKey="dweb_certifications_roadie_xd_learn_about_roadie_xd_gigs_various_scheduling_options" />
                </Text.Body2>
                <Spacer $height="1.6rem" />
                <VimeoVideo id="963534767" thumbnail={videoThumb1} />
              </Slide>
              <Slide>
                <Text.H5 $fontWeight="600">
                  <LocalizedText translationKey="dweb_certifications_roadie_xd_picking_up_at_cross_dock" />
                </Text.H5>
                <Spacer $height="0.8rem" />
                <Text.Body2>
                  <LocalizedText translationKey="dweb_certifications_roadie_xd_explore_specifics_warehouse_safety_pickup_procedures" />
                </Text.Body2>
                <Spacer $height="1.6rem" />
                <VimeoVideo id="963535457" thumbnail={videoThumb2} />
              </Slide>
              <Slide>
                <Text.H5 $fontWeight="600">
                  <LocalizedText translationKey="dweb_certifications_roadie_xd_loading_sorting_vehicle" />
                </Text.H5>
                <Spacer $height="0.8rem" />
                <Text.Body2>
                  <LocalizedText translationKey="dweb_certifications_roadie_xd_securing_gigs_guidelines" />
                </Text.Body2>
                <Spacer $height="1.6rem" />
                <VimeoVideo id="1128954851" h="e27e3f7f35" thumbnail={videoThumb3} />
              </Slide>
              <Slide>
                <Text.H5 $fontWeight="600">
                  <LocalizedText translationKey="dweb_certifications_roadie_xd_delivery_returns" />
                </Text.H5>
                <Spacer $height="0.8rem" />
                <Text.Body2>
                  <LocalizedText translationKey="dweb_certifications_roadie_xd_get_familiar_ins_outs_delivering_gigs_from_cross" />
                </Text.Body2>
                <Spacer $height="1.6rem" />
                <VimeoVideo id="963535736" thumbnail={videoThumb4} />
              </Slide>
              <Slide>
                <img src={bannerQuizImage} alt={t('dweb_certifications_pharmacy_pharmacy_show_what_know_banner')} />
                <Spacer $height="3.2rem" />
                <Text.H5 $fontWeight="600">
                  <LocalizedText translationKey="dweb_certifications_pharmacy_pharmacy_show_what_know" />
                </Text.H5>
                <Spacer $height="0.8rem" />
                <Text.Body2>
                  <LocalizedText translationKey="dweb_certifications_roadie_xd_now_its_time_short_quiz_reinforce_what_youve" />
                </Text.Body2>
              </Slide>
            </>
          ),
          questions: (
            <>
              <Slide>
                <RequiredQuiz
                  questionNumber={1}
                  totalQuestions={4}
                  questionKey="dweb_certifications_roadie_xd_quiz_q1_question"
                  descriptionKey="dweb_certifications_roadie_xd_quiz_q1_description"
                  options={[
                    {
                      textKey: 'dweb_certifications_roadie_xd_quiz_q1_option_1',
                      value: '1',
                    },
                    {
                      textKey: 'dweb_certifications_roadie_xd_quiz_q1_option_2',
                      value: '2',
                      isCorrect: true,
                    },
                    {
                      textKey: 'dweb_certifications_roadie_xd_quiz_q1_option_3',
                      value: '3',
                    },
                    {
                      textKey: 'dweb_certifications_roadie_xd_quiz_q1_option_4',
                      value: '4',
                    },
                  ]}
                />
              </Slide>
              <Slide>
                <RequiredQuiz
                  questionNumber={2}
                  totalQuestions={4}
                  questionKey="dweb_certifications_roadie_xd_quiz_q2_question"
                  descriptionKey="dweb_certifications_roadie_xd_quiz_q2_description"
                  options={[
                    {
                      textKey: 'dweb_certifications_roadie_xd_quiz_q2_option_1',
                      value: '1',
                    },
                    {
                      textKey: 'dweb_certifications_roadie_xd_quiz_q2_option_2',
                      value: '2',
                      isCorrect: true,
                    },
                  ]}
                />
              </Slide>
              <Slide>
                <RequiredQuiz
                  questionNumber={3}
                  totalQuestions={4}
                  questionKey="dweb_certifications_roadie_xd_quiz_q3_question"
                  descriptionKey="dweb_certifications_roadie_xd_quiz_q3_description"
                  options={[
                    {
                      textKey: 'dweb_certifications_roadie_xd_quiz_q3_option_1',
                      value: '1',
                    },
                    {
                      textKey: 'dweb_certifications_roadie_xd_quiz_q3_option_2',
                      value: '2',
                    },
                    {
                      textKey: 'dweb_certifications_roadie_xd_quiz_q3_option_3',
                      value: '3',
                      isCorrect: true,
                    },
                    {
                      textKey: 'dweb_certifications_roadie_xd_quiz_q3_option_4',
                      value: '4',
                    },
                  ]}
                />
              </Slide>
              <Slide>
                <RequiredQuiz
                  questionNumber={4}
                  totalQuestions={4}
                  questionKey="dweb_certifications_roadie_xd_quiz_q4_question"
                  descriptionKey="dweb_certifications_roadie_xd_quiz_q4_description"
                  options={[
                    {
                      textKey: 'dweb_certifications_roadie_xd_quiz_q4_option_1',
                      value: '1',
                    },
                    {
                      textKey: 'dweb_certifications_roadie_xd_quiz_q4_option_2',
                      value: '2',
                      isCorrect: true,
                    },
                    {
                      textKey: 'dweb_certifications_roadie_xd_quiz_q4_option_3',
                      value: '3',
                    },
                    {
                      textKey: 'dweb_certifications_roadie_xd_quiz_q4_option_4',
                      value: '4',
                    },
                  ]}
                />
              </Slide>
            </>
          ),
          agreement: (
            <>
              <Slide>
                <Text.H5 $fontWeight="600">
                  <LocalizedText translationKey="dweb_certifications_roadie_xd_one_last_step" />
                </Text.H5>
                <Spacer $height="1.6rem" />
                <Text.Body2>
                  <LocalizedRichText
                    translationKey="dweb_certifications_roadie_xd_assessment_intro"
                    params={{
                      strongText1: (
                        <strong>
                          <LocalizedText translationKey="dweb_certifications_roadie_xd_great_job_assessment" />
                        </strong>
                      ),
                      br: <br />,
                    }}
                  />
                </Text.Body2>
                <Spacer $height="1.6rem" />
                <Agree
                  toRichKey="dweb_certifications_roadie_xd_agree_has_equipment"
                  params={{
                    strongText1: (
                      <strong>
                        <LocalizedText translationKey="dweb_certifications_roadie_xd_i_have_proper_equipment_safely_manage_items_weighing" />
                      </strong>
                    ),
                  }}
                />
                <Agree
                  toRichKey="dweb_certifications_roadie_xd_agree_physically_able"
                  params={{
                    strongText1: (
                      <strong>
                        <LocalizedText translationKey="dweb_certifications_roadie_xd_physically_able_load_unload_without_assistance" />
                      </strong>
                    ),
                  }}
                />
                <Agree
                  toRichKey="dweb_certifications_mail_innovations_agree_no_early_arrival"
                  params={{
                    strongText1: (
                      <strong>
                        <LocalizedText translationKey="dweb_certifications_mail_innovations_no_early_waiting_ack" />
                      </strong>
                    ),
                  }}
                />
                <Agree
                  toRichKey="dweb_certifications_mail_innovations_agree_theft_prosecution"
                  params={{
                    strongText1: (
                      <strong>
                        <LocalizedText translationKey="dweb_certifications_mail_innovations_theft_any_kind_amount_will_prosecuted" />
                      </strong>
                    ),
                  }}
                />
                <Agree
                  toRichKey="dweb_certifications_mail_innovations_agree_professional_conduct"
                  params={{
                    strongText1: (
                      <strong>
                        <LocalizedText translationKey="dweb_certifications_mail_innovations_treat_all_staff_at_cross_dock_respect_conduct" />
                      </strong>
                    ),
                  }}
                />
                <Agree
                  toRichKey="dweb_certifications_mail_innovations_agree_no_passengers_or_animals"
                  params={{
                    strongText1: (
                      <strong>
                        <LocalizedText translationKey="dweb_certifications_mail_innovations_no_passengers_acknowledgement" />
                      </strong>
                    ),
                  }}
                />
                <Agree
                  toRichKey="dweb_certifications_mail_innovations_agree_follow_safety_procedures"
                  params={{
                    strongText1: (
                      <strong>
                        <LocalizedText translationKey="dweb_certifications_mail_innovations_safety_attire_acknowledgement" />
                      </strong>
                    ),
                  }}
                />
                <Agree
                  toRichKey="dweb_certifications_roadie_xd_agree_bring_license_and_insurance"
                  params={{
                    strongText1: (
                      <strong>
                        <LocalizedText translationKey="dweb_certifications_roadie_xd_must_bring_physical_copy_my_drivers_license_proof" />
                      </strong>
                    ),
                  }}
                />
                <Agree
                  toRichKey="dweb_certifications_roadie_xd_agree_complete_all_deliveries"
                  params={{
                    strongText1: (
                      <strong>
                        <LocalizedText translationKey="dweb_certifications_roadie_xd_offering_roadie_xd_gig_scheduled_block_means_i" />
                      </strong>
                    ),
                  }}
                />
                <Agree
                  toRichKey="dweb_certifications_roadie_xd_agree_strict_compliance"
                  params={{
                    strongText1: (
                      <strong>
                        <LocalizedText translationKey="dweb_certifications_roadie_xd_strictly_comply_roadie_terms_conditions_any_roadie_xd" />
                      </strong>
                    ),
                  }}
                />
                <Spacer $height="1.6rem" />
              </Slide>
            </>
          ),
          resultSlide: (results: { passed: boolean; numCorrectAnswers: number; resetModule: VoidFunction }) =>
            results.passed ? (
              <Slide>
                <Image width="100%" src={bannerPassImage} />
                <Spacer $height="3.2rem" />
                <Text.H5 $fontWeight="600">
                  <LocalizedText translationKey="dweb_certifications_mail_innovations_great_job" />
                </Text.H5>
                <Spacer $height="1.6rem" />
                <Text.Body2>
                  <LocalizedText translationKey="dweb_certifications_roadie_xd_completion_success" />
                </Text.Body2>
              </Slide>
            ) : (
              <Slide>
                <img src={bannerFailImage} alt={t('dweb_common_failed_banner')} />
                <Spacer $height="3.2rem" />
                <Text.H4>
                  <LocalizedText translationKey="dweb_certifications_pharmacy_pharmacy_oh_no" />
                </Text.H4>
                <Spacer $height="0.8rem" />
                <Text.Body2 $fontWeight="bold">
                  <LocalizedRichText
                    translationKey="dweb_certifications_roadie_xd_only_got_value1_out_4_correct"
                    params={{
                      value1: results.numCorrectAnswers,
                    }}
                  />
                </Text.Body2>
                <br />
                <Text.Body2>
                  <LocalizedText translationKey="dweb_certifications_roadie_xd_while_we_appreciate_dedication_it_looks_like_didnt" />
                  <br />
                  <br />
                  <LocalizedText translationKey="dweb_certifications_returns_returns_good_luck" />
                </Text.Body2>
                <Spacer $height="4.0rem" />
                <Button.Primary onClick={results.resetModule} $width="100%">
                  <LocalizedText translationKey="dweb_certifications_pharmacy_pharmacy_start_over" />
                </Button.Primary>
              </Slide>
            ),
        }}
      </QuizModule>
    </RoadieXDModule>
  )
}
const RoadieXDModule: React.FC<React.PropsWithChildren> = (props) => {
  const { t } = useLocalization()

  return (
    <Container.Base $color="neutral-black">
      <Framework title={t('dweb_certifications_roadie_xd_title')} {...props} />
    </Container.Base>
  )
}
export default RoadieXDPage
